let enabled = true;

export const setPermutiveEnabledStatus = (newStatus: boolean): void => {
  if (typeof newStatus !== "boolean") {
    return;
  }
  enabled = newStatus;
};

export const getPermutiveEnabledStatus = (): boolean => enabled;
